exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n  max-height: 55vh;\n  padding: 0; }\n\nh6 {\n  padding-bottom: 8px; }\n\n#colaboradores-scroll {\n  overflow-y: scroll;\n  height: 45vh; }\n\n.divider {\n  margin: 0 -24px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/colaboradores-dialog/colaboradores-dialog.component.scss
// module id = ../../../../../src/app/components/common/dialog/colaboradores-dialog/colaboradores-dialog.component.scss
// module chunks = 0